// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"498ae2a7","395":"254a9254"}[chunkId] + ".chunk.js";
};